// Provider response adapter over the existing authorised Cartrack status API.
// No job association, machine activity or physical presence is inferred from GPS.
const regoKey = value => String(value || '').replace(/[\s-]/g, '').toUpperCase();
export const validGeo = geo => geo && typeof geo.lat === 'number' && typeof geo.lng === 'number' && Number.isFinite(geo.lat) && Number.isFinite(geo.lng) && Math.abs(geo.lat) <= 90 && Math.abs(geo.lng) <= 180;
export function gpsByAsset(assets, response) {
  const rows = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];
  const localCounts = new Map();
  assets.forEach(a => { const key = regoKey(a.rego); if (key) localCounts.set(key, (localCounts.get(key) || 0) + 1); });
  const remote = new Map();
  rows.forEach(row => { const key = regoKey(row.registration || row.rego); if (key) remote.set(key, [...(remote.get(key) || []), row]); });
  return assets.map(asset => {
    const matches = remote.get(regoKey(asset.rego));
    if (localCounts.get(regoKey(asset.rego)) !== 1 || matches?.length !== 1) return asset;
    const row = matches[0], loc = row.location || {};
    const lat = loc.latitude ?? row.latitude ?? row.lat;
    const lng = loc.longitude ?? row.longitude ?? row.lon ?? row.lng;
    if (lat == null || lng == null || lat === '' || lng === '' || typeof lat === 'boolean' || typeof lng === 'boolean') return asset;
    const geo = {lat:Number(lat),lng:Number(lng)};
    if (!validGeo(geo)) return asset;
    return {...asset, gps: {source:'gps',provider:(row.provider || 'Cartrack'),geo,recorded_at:row.event_ts || loc.updated || row.timestamp || null}};
  });
}
export function gpsAge(location, now = Date.now()) {
  // Timestamp without an offset has unknown timezone: display verbatim, never call it live.
  const raw = location?.recorded_at;
  if (typeof raw !== 'string' || !/(Z|[+-]\d{2}:?\d{2})$/i.test(raw)) return null;
  const time = Date.parse(raw);
  return Number.isFinite(time) && time <= now ? Math.floor((now-time)/60000) : null;
}
export function locationLabel(asset, now = Date.now()) {
  if (asset.gps) {
    const age = gpsAge(asset.gps,now);
    return age == null ? 'GPS · timestamp unconfirmed' : age < 1 ? 'GPS · <1m ago' : `${age > 15 ? 'Last known GPS' : 'GPS'} · ${age < 60 ? `${age}m` : `${Math.floor(age/60)}h ${age%60}m`} ago`;
  }
  const location = asset.map_location || asset.location;
  if (location?.source === 'allocated_job') return 'Allocated Job · not GPS';
  if (location?.source === 'timesheet_job') return `${location.current ? 'Timesheet Job' : 'Last recorded Job'} · ${location.date || 'date unknown'} · not GPS`;
  return 'Location unknown';
}
export const assetGeo = asset => asset.gps?.geo || asset.map_location?.geo || asset.location?.geo || asset.last_geo;
